export const purpurShadowNone = "0rem 0rem 0rem 0rem rgba(0, 0, 0, 0.1)";
export const purpurShadowSm = "0rem 0.0625rem 0.25rem 0rem rgba(0, 0, 0, 0.1)";
export const purpurShadowMd = "0rem 0.25rem 0.75rem 0rem rgba(0, 0, 0, 0.1)";
export const purpurShadowLg = "0rem 0.75rem 1.5rem 0rem rgba(0, 0, 0, 0.1)";
